<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    mini-variant=""
    mini-variant-width="78"
    floating=""
    persistent
    mobile-break-point="991"
    width="600"   
  >
     <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <div>

          <v-list-item>
            <v-list-item-avatar
              @click="toggleUserSettings()"
              color="primary"                  
            >
            <span class="white--text subheading">{{user.initials}}</span>
            </v-list-item-avatar>
          </v-list-item>

          <dialog-user-settings></dialog-user-settings>

          <v-list-item
            to="/objecten"
            v-if="user.organisation.managed_list.length > 0"
            active-class="active-button primary"
            class="drawer-button">
            <v-list-item-action>
              <v-icon>mdi-city</v-icon>
            </v-list-item-action>
          </v-list-item>          

          <v-list-item
            to="/crm"
            v-if="user.organisation.crm_list.length > 0"
            active-class="active-button primary"
            class="drawer-button">
            <v-list-item-action>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-action>
          </v-list-item>       

          <v-list-item
            to="/contracten"
            active-class="active-button primary"
            class="drawer-button">
            <v-list-item-action>
              <v-icon>mdi-file-multiple</v-icon>
            </v-list-item-action>
          </v-list-item>          

          <v-list-item
            to="/formulieren"
            active-class="active-button primary"
            v-if="user.organisation.forms"           
            class="drawer-button">
            <v-list-item-action>
              <v-icon>mdi-format-line-style</v-icon>
            </v-list-item-action>
          </v-list-item>        

          </div>
        <div style="margin-top:auto">
          <!-- settings -->
          <v-list-item
            v-if="user.authorization == 'admin' || user.authorization == 'superuser'"
            active-class="active-button primary"
            class="drawer-button"
            to="/settings"
          >
            <v-list-item-action>
              <v-icon >mdi-dots-horizontal</v-icon>
            </v-list-item-action>
          
          </v-list-item>

          <!-- logout -->
          <v-list-item
            active-class="active-button primary"
            class="drawer-button"
            @click="logout()"
          >
            <v-list-item-action>
              <v-icon >mdi-power-standby</v-icon>
            </v-list-item-action>
            
            </v-list-item>
          </div>
      </v-layout>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapActions, mapState } from "vuex";

export default {
  data: () => ({
    responsive: false
  }),
  computed: {
    ...mapState(["user"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    items() {
      return this.$t("Layout.View.items");
    },
    color() {
      return this.$store.state.app.color;
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer", "toggleUserSettings"]),
    ...mapActions(["logout", "toContracts"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>

<style lang="scss">
.v-navigation-drawer {
  background: transparent !important;
}

.theme--dark.v-list-item--active {
  color: transparent !important;
  opacity: 1 !important;
}
.theme--dark.v-list-item--active {
  .v-icon {
    color: white !important;
  }
}

.drawer-button {
  min-height: 70px !important;
  min-width: 78px !important;
}

.active-button {
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
}
</style>


